import * as moment from 'moment';

import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { OrderStatus } from '../../orders/enums/order-status.enum';
import { TotalSubtablePagination } from './total-subtable-pagination';

export class TotalOrdersReport {
  dateGroup: string;
  date: number;
  customer: string;
  totalOrders: number;
  status: string;
  total: number;
  totalCanceled: number;
  orderId: number;

  // Controla paginação e dados da sub tabela
  ordersPagination: TotalSubtablePagination;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    moment.locale('pt-BR');
  }

  public getStatusDescription(): string {
    const orderStatus: OrderStatus = UtilHelper.getEnumByCod(this.status, OrderStatus);
    return (orderStatus && orderStatus['description']) || '';
  }

  public getFormatDate(): string {
    return moment(this.dateGroup).format('ddd DD/MM/YYYY');
  }

  public getFormatHour(): string {
    return moment(this.date).format('HH:mm');
  }
}

export interface TotalOrdersReportResponse {
  ordersReport: Array<TotalOrdersReport>;
  count: number;
}



// WEBPACK FOOTER //
// ./src/app/pages/statistics/models/total-orders-report.ts